/**
 * Project : workspace
 * File    : InventoryNavGraph.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.graph.inventory

import androidx.compose.runtime.Composable
import androidx.navigation.NavGraph
import androidx.navigation.compose.composable
import androidx.navigation.createGraph
import navigation.base.FriendlyWindow
import navigation.graph.inventory.brand.InventoryBrandNavGraph
import navigation.graph.inventory.color.InventoryColorNavGraph
import navigation.graph.inventory.coupon.InventoryCouponNavGraph
import navigation.graph.inventory.discount.InventoryDiscountNavGraph
import navigation.graph.inventory.product.ProductNavGraph
import navigation.graph.inventory.productCategory.ProductCategoryNavGraph
import navigation.graph.inventory.productSubCategory.ProductSubCategoryNavGraph
import navigation.graph.inventory.size.InventorySizeNavGraph
import navigation.graph.inventory.tag.InventoryTagNavGraph
import navigation.graph.inventory.uom.InventoryUOMNavGraph
import navigation.route.inventory.InventoryNavRoute
import presentation.screens.business.inventory.details.InventoryDetailsScreen
import presentation.screens.business.inventory.home.InventoryHomeScreen
import presentation.screens.business.inventory.stock.create.CreateStockScreen
import presentation.screens.business.inventory.stock.edit.UpdateStockScreen
import presentation.screens.business.inventory.stock.list.InventoryListScreen
import presentation.screens.business.inventory.stock.product_list.StockProductListScreen

/**
 * Represents the inventory nav graph class.
 */

class InventoryNavGraph {
    @Composable
    fun navGraph(): NavGraph {
        val graph =
            FriendlyWindow.navigationController?.createGraph(startDestination = InventoryNavRoute.HOME) {
                composable(route = InventoryNavRoute.HOME) {
                    InventoryHomeScreen().content()
                }
                composable(route = InventoryNavRoute.PRODUCTS) {
                    StockProductListScreen().Content()
                }
                composable(route = InventoryNavRoute.LIST) {
                    InventoryListScreen().Content()
                }
                composable(route = InventoryNavRoute.CREATE) {
                    CreateStockScreen().Content()
                }
                composable(route = InventoryNavRoute.UPDATE) {
                    UpdateStockScreen().Content()
                }
                composable(route = InventoryNavRoute.DETAILS) {
                    InventoryDetailsScreen().Content()
                }
            }
        graph?.addAll(ProductNavGraph().navGraph())
        graph?.addAll(ProductCategoryNavGraph().navGraph())
        graph?.addAll(ProductSubCategoryNavGraph().navGraph())
        graph?.addAll(InventoryUOMNavGraph().navGraph())
        graph?.addAll(InventoryTagNavGraph().navGraph())
        graph?.addAll(InventorySizeNavGraph().navGraph())
        graph?.addAll(InventoryBrandNavGraph().navGraph())
        graph?.addAll(InventoryColorNavGraph().navGraph())
        graph?.addAll(InventoryCouponNavGraph().navGraph())
        graph?.addAll(InventoryDiscountNavGraph().navGraph())
        return graph!!
    }
}